import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/panzhijing/\u86CB\u5377\u79D1\u6280/danjuan-admin/node_modules/_@babel_runtime-corejs2@7.26.0@@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import adminUserApi from '@/api/adminuserApi';
import dateutil from "../../utils/dateutils";
import * as _ from 'lodash';
var state = {
  permissionList: [],
  headers: {},
  roleList: [],
  userList: []
};
var mutations = {
  SET_USER_LIST: function SET_USER_LIST(state, users) {
    state.userList = users;
  },
  SET_ROLE_LIST: function SET_ROLE_LIST(state, roles) {
    state.roleList = roles;
  },
  SET_HEADERS: function SET_HEADERS(state, roles) {
    state.headers = roles;
  },
  SET_PERMISSION_LIST: function SET_PERMISSION_LIST(state, permissions) {
    state.permissionList = permissions;
  }
};
var actions = {
  addAdminUsers: function () {
    var _addAdminUsers = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, adminUser) {
      var commit, state, _yield$adminUserApi$a, data, status, message;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit, state = _ref.state;
            _context.prev = 1;
            _context.next = 4;
            return adminUserApi.addAdminUser(adminUser, state.headers);
          case 4:
            _yield$adminUserApi$a = _context.sent;
            data = _yield$adminUserApi$a.data;
            status = _yield$adminUserApi$a.status;
            message = _yield$adminUserApi$a.message;
            if (!(status === '0')) {
              _context.next = 13;
              break;
            }
            if (data) {}
            return _context.abrupt("return", data);
          case 13:
            return _context.abrupt("return", Promise.reject(message));
          case 14:
            _context.next = 19;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", Promise.reject('异常：' + _context.t0));
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 16]]);
    }));
    function addAdminUsers(_x, _x2) {
      return _addAdminUsers.apply(this, arguments);
    }
    return addAdminUsers;
  }(),
  editAdminUsers: function () {
    var _editAdminUsers = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2, adminUser) {
      var commit, state, _yield$adminUserApi$e, data, status, message;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref2.commit, state = _ref2.state;
            _context2.prev = 1;
            _context2.next = 4;
            return adminUserApi.editAdminUsers(adminUser, state.headers);
          case 4:
            _yield$adminUserApi$e = _context2.sent;
            data = _yield$adminUserApi$e.data;
            status = _yield$adminUserApi$e.status;
            message = _yield$adminUserApi$e.message;
            if (!(status === '0')) {
              _context2.next = 13;
              break;
            }
            if (data) {}
            return _context2.abrupt("return", data);
          case 13:
            return _context2.abrupt("return", Promise.reject(message));
          case 14:
            _context2.next = 19;
            break;
          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](1);
            return _context2.abrupt("return", Promise.reject('异常：' + _context2.t0));
          case 19:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 16]]);
    }));
    function editAdminUsers(_x3, _x4) {
      return _editAdminUsers.apply(this, arguments);
    }
    return editAdminUsers;
  }(),
  delAdminUsers: function () {
    var _delAdminUsers = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref3, _ref4) {
      var commit, state, userId, _yield$adminUserApi$d, data, status, message;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref3.commit, state = _ref3.state;
            userId = _ref4.userId;
            _context3.prev = 2;
            _context3.next = 5;
            return adminUserApi.delAdminUsers({
              userId: userId
            }, state.headers);
          case 5:
            _yield$adminUserApi$d = _context3.sent;
            data = _yield$adminUserApi$d.data;
            status = _yield$adminUserApi$d.status;
            message = _yield$adminUserApi$d.message;
            if (!(status === '0')) {
              _context3.next = 13;
              break;
            }
            return _context3.abrupt("return", data);
          case 13:
            return _context3.abrupt("return", Promise.reject(message));
          case 14:
            _context3.next = 19;
            break;
          case 16:
            _context3.prev = 16;
            _context3.t0 = _context3["catch"](2);
            return _context3.abrupt("return", Promise.reject('异常：' + _context3.t0));
          case 19:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 16]]);
    }));
    function delAdminUsers(_x5, _x6) {
      return _delAdminUsers.apply(this, arguments);
    }
    return delAdminUsers;
  }(),
  // get admin users
  getAdminUsers: function () {
    var _getAdminUsers = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref5, params) {
      var commit, state, _yield$adminUserApi$g, data, status, message;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref5.commit, state = _ref5.state;
            _context4.prev = 1;
            _context4.next = 4;
            return adminUserApi.getAdminUsers(params, state.headers);
          case 4:
            _yield$adminUserApi$g = _context4.sent;
            data = _yield$adminUserApi$g.data;
            status = _yield$adminUserApi$g.status;
            message = _yield$adminUserApi$g.message;
            if (!(status === '0')) {
              _context4.next = 13;
              break;
            }
            if (data) {
              data.forEach(function (item) {
                if (item.roles) {
                  item.rolesText = _.join(item.roles.map(function (i) {
                    return i.name;
                  }), ',');
                }
                if (item.permissions) {
                  item.permissionCount = item.permissions.length;
                }
                item.createdOnText = dateutil.formatStandardTime(item.createdOn);
                item.updatedOnText = dateutil.formatStandardTime(item.updatedOn);
              });
              data = _.sortBy(data, ['roleId']);
              commit('SET_USER_LIST', data);
            } else {
              commit('SET_USER_LIST', []);
            }
            return _context4.abrupt("return", data);
          case 13:
            return _context4.abrupt("return", Promise.reject(message));
          case 14:
            _context4.next = 19;
            break;
          case 16:
            _context4.prev = 16;
            _context4.t0 = _context4["catch"](1);
            return _context4.abrupt("return", Promise.reject('异常：' + _context4.t0));
          case 19:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[1, 16]]);
    }));
    function getAdminUsers(_x7, _x8) {
      return _getAdminUsers.apply(this, arguments);
    }
    return getAdminUsers;
  }(),
  getAdminRoles: function () {
    var _getAdminRoles = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref6) {
      var commit, state, _yield$adminUserApi$g2, data, status, message;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            commit = _ref6.commit, state = _ref6.state;
            _context5.prev = 1;
            console.log('loading admin roles');
            _context5.next = 5;
            return adminUserApi.getAdminRoles(state.headers);
          case 5:
            _yield$adminUserApi$g2 = _context5.sent;
            data = _yield$adminUserApi$g2.data;
            status = _yield$adminUserApi$g2.status;
            message = _yield$adminUserApi$g2.message;
            if (!(status === '0')) {
              _context5.next = 15;
              break;
            }
            if (data) {
              data.forEach(function (item) {
                if (item.roleResouces) {
                  item.permissionCount = item.roleResouces.length;
                  item.permissionsText = _.join(item.roleResouces.map(function (i) {
                    return i.name;
                  }), '、');
                } else {
                  item.permissionCount = 0;
                  item.permissionsText = '';
                }
                item.createdOnText = dateutil.formatStandardTime(item.createTime);
                item.updatedOnText = dateutil.formatStandardTime(item.changeTime);
              });
            }
            commit('SET_ROLE_LIST', data);
            return _context5.abrupt("return", data);
          case 15:
            return _context5.abrupt("return", Promise.reject(message));
          case 16:
            _context5.next = 21;
            break;
          case 18:
            _context5.prev = 18;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", Promise.reject('异常：' + _context5.t0));
          case 21:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[1, 18]]);
    }));
    function getAdminRoles(_x9) {
      return _getAdminRoles.apply(this, arguments);
    }
    return getAdminRoles;
  }(),
  delAdminRole: function () {
    var _delAdminRole = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref7, _ref8) {
      var commit, state, roleId, _yield$adminUserApi$d2, data, status, message;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            commit = _ref7.commit, state = _ref7.state;
            roleId = _ref8.roleId;
            _context6.prev = 2;
            console.log('delAdminRole ', roleId);
            _context6.next = 6;
            return adminUserApi.delAdminRole({
              roleId: roleId
            }, state.headers);
          case 6:
            _yield$adminUserApi$d2 = _context6.sent;
            data = _yield$adminUserApi$d2.data;
            status = _yield$adminUserApi$d2.status;
            message = _yield$adminUserApi$d2.message;
            if (!(status === '0')) {
              _context6.next = 14;
              break;
            }
            return _context6.abrupt("return", data);
          case 14:
            return _context6.abrupt("return", Promise.reject(message));
          case 15:
            _context6.next = 20;
            break;
          case 17:
            _context6.prev = 17;
            _context6.t0 = _context6["catch"](2);
            return _context6.abrupt("return", Promise.reject('异常：' + _context6.t0));
          case 20:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[2, 17]]);
    }));
    function delAdminRole(_x10, _x11) {
      return _delAdminRole.apply(this, arguments);
    }
    return delAdminRole;
  }(),
  /**
   * 获取管理员用户的权限列表
   * @param commit
   * @param params
   * @returns {Promise<*|Promise<never>|undefined>}
   */
  getAdminPermissions: function () {
    var _getAdminPermissions = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref9) {
      var commit, state, _yield$adminUserApi$g3, data, status, message;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            commit = _ref9.commit, state = _ref9.state;
            _context7.prev = 1;
            console.log('loading admin permissions');
            _context7.next = 5;
            return adminUserApi.getAdminPermissions(state.headers);
          case 5:
            _yield$adminUserApi$g3 = _context7.sent;
            data = _yield$adminUserApi$g3.data;
            status = _yield$adminUserApi$g3.status;
            message = _yield$adminUserApi$g3.message;
            if (!(status === '0')) {
              _context7.next = 14;
              break;
            }
            commit('SET_PERMISSION_LIST', data);
            return _context7.abrupt("return", data);
          case 14:
            return _context7.abrupt("return", Promise.reject(message));
          case 15:
            _context7.next = 20;
            break;
          case 17:
            _context7.prev = 17;
            _context7.t0 = _context7["catch"](1);
            return _context7.abrupt("return", Promise.reject('异常：' + _context7.t0));
          case 20:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[1, 17]]);
    }));
    function getAdminPermissions(_x12) {
      return _getAdminPermissions.apply(this, arguments);
    }
    return getAdminPermissions;
  }(),
  updateAdminRolePermissions: function () {
    var _updateAdminRolePermissions = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref10, _ref11) {
      var commit, dispatch, state, roleId, roleInfo, _yield$adminUserApi$u, data, status, message;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            commit = _ref10.commit, dispatch = _ref10.dispatch, state = _ref10.state;
            roleId = _ref11.roleId, roleInfo = _ref11.roleInfo;
            _context8.prev = 2;
            _context8.next = 5;
            return adminUserApi.updateAdminRolePermissions(roleId, roleInfo, state.headers);
          case 5:
            _yield$adminUserApi$u = _context8.sent;
            data = _yield$adminUserApi$u.data;
            status = _yield$adminUserApi$u.status;
            message = _yield$adminUserApi$u.message;
            if (!(status === '0')) {
              _context8.next = 14;
              break;
            }
            dispatch('getAdminRoles');
            return _context8.abrupt("return", data);
          case 14:
            return _context8.abrupt("return", Promise.reject(message));
          case 15:
            _context8.next = 20;
            break;
          case 17:
            _context8.prev = 17;
            _context8.t0 = _context8["catch"](2);
            return _context8.abrupt("return", Promise.reject('异常：' + _context8.t0));
          case 20:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[2, 17]]);
    }));
    function updateAdminRolePermissions(_x13, _x14) {
      return _updateAdminRolePermissions.apply(this, arguments);
    }
    return updateAdminRolePermissions;
  }()
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};